export const TextStyle = `font-secondary`

export const Padding = `pt-1 pb-1`

export const SetItalic = `italic`

export const SetBold = `font-bold`

export const SetUppercase = `uppercase`

export const Size = {}
